const pointsMap = {
    down: '4,6 8,2 0,2',
    right: '2,4 6,8 6,0',
    up: '4,2 0,6 8,6',
    left: '6,4 2,0 2,8',
};

type CaretOrientation = keyof typeof pointsMap;

interface CaretIconProps {
    color?: string;
    orientation?: CaretOrientation;
    className?: string | null;
}

function CaretIcon({
    color = 'currentColor',
    orientation = 'down',
    className = null,
}: CaretIconProps) {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="8px"
            height="8px"
            viewBox="0 0 8 8"
            xmlSpace="preserve"
            className={className || undefined}
        >
            <polygon fill={color} points={pointsMap[orientation]} />
        </svg>
    );
}

export default CaretIcon;
